import qs from 'qs';
import { coreAxios } from './axios';
import { AxiosResponse } from 'axios';
import { Organization } from '../interface/organization';


export function getOrganizaitonList(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/organizations`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function getOrganizaitonDetail(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/organizations/${id}`, {
        params: {
            ...params,
        },
    })
}

export function updateOrganization(id: number, data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/organizations/${id}`, data, {
        params: params
    })
}

export function deleteOrgMulti(ids: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/organizations/multi-delete`, ids, {
        params: params
    })
}

export function createOrganization(org: Organization, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/organizations`, org, {
        params: params
    })
}